import { type Draft } from 'immer'
import { matchesRef } from '../../../schema/validation/resourceObject'
import { type BoardObjectsTransform, type IncludedResource } from './types'

export const upsertIncluded =
  (resource: IncludedResource): BoardObjectsTransform =>
  (draft) => {
    if (!draft.included) draft.included = []

    const index = draft.included.findIndex(
      matchesRef({ type: resource.type, id: resource.id })
    )
    if (index === -1) {
      draft.included.push(resource as Draft<IncludedResource>)
    } else {
      draft.included[index] = resource as Draft<IncludedResource>
    }
    return draft
  }
